import { Component, OnDestroy, OnInit } from '@angular/core';
import { requestPayload, Promotions } from '../../../../shared/models/model';
import { WidgetsService } from '../../../../shared/services/widgets.service';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-promotions-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './promotions-widget.component.html',
  styleUrl: './promotions-widget.component.scss',
})
export class PromotionsWidgetComponent implements OnInit, OnDestroy {
  promotionInfos: Promotions[] = [];
  errorMessage: string = '';
  ratePromotionsSubscription: Subscription = new Subscription();
  constructor(private _widgetService: WidgetsService) {}
  ngOnInit(): void {
    this.getRatePromotionsList();
  }

  getRatePromotionsList() {
    // payload for fetching promos
    const payLoad: requestPayload = {
      requestingSystem: 'FinPro',
    };
    this._widgetService.fetchPromotionsList(payLoad).subscribe({
      next: (data: any) => {
        this.promotionInfos = data?.promosList;
      },
      error: (error: string) => {
        this.errorMessage = error;
      },
    });
  }
  ngOnDestroy(): void {
    this.ratePromotionsSubscription.unsubscribe();
  }
}
